<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="pt-2">
    <div class="col-sm-12 nopads px-2">
      <!-- Search criteria -->
      <work-time-search ref="searchView" @search="searchWithParams"/>
      <hr/>
      <div class="col-12 d-flex justify-content-end my-2 px-2">
        <button class="btn btn-success form-button" @click="addItem">
          {{ $t('common.add_new') }}
        </button>
      </div>

      <base-modal
        v-if="editMode"
        size="lg"
        hide-header
        hide-footer
        @close="showList"
      >
        <meal-allowance-editor
          :allowance="result"
          :is-observer="isObserver"
          @close-and-update="updateList"
          @close="showList"
        />
      </base-modal>

      <div class="col-sm-12 list-container nopads">
        <div v-if="resultList && resultList.length > 0" class="list-content result-table">
            <vue3-datatable
                ref="resultTable"
                :rows="resultList"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                height="52em"
                :sortable="true"
                skin="bh-table-compact"
                row-class="routa-table-row"
                cell-class="routa-table-cell"
                @row-click="editItem"
            >
                <template
                    #date="row"
                >
                    <span v-if="row.value && row.value.date">{{ getShortDateString(row.value.date) }}</span>
                </template>
            </vue3-datatable>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import WorkTimeSearch from '../worktime/WorkTimeSearch'
import {timeUtils} from '../mixins/TimeUtils'
import {allowanceHelper} from '../mixins/AllowanceMixin'
import MealAllowanceEditor from "./MealAllowanceEditor";
import BaseModal from "@/components/BaseModal.vue";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'MealAllowances',
    components: {Vue3Datatable, BaseModal, MealAllowanceEditor, WorkTimeSearch},
    mixins: [restApi, timeUtils, allowanceHelper],
    props: {
        isObserver: Boolean
    },
    data: function () {
        return {
            loading: false,
            searchParams: null,
            editMode: false,
            results: [],
            resultList: [],
            result: null,
            fields: [
                {field: 'user', title: this.$t('daily_allowance.user'), sort: true, headerClass: 'routa-table-header'},
                {field: 'date', title: this.$t('work_report.start_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'approver', title: this.$t('meal_allowance.approver'), sort: true, headerClass: 'routa-table-header'},
                {field: 'increased_allowance', title: this.$t('meal_allowance.type'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        results() {
            // Convert to table items
            let temp = []
            this.resultList = []
            this.results.forEach(item =>
                temp.push({
                    ...item,
                    'user': item.user ? item.user.first_name + ' ' + item.user.last_name : '',
                    'date': item.date,
                    'increased_allowance': item.increased_allowance ? this.getTypeString(item.increased_allowance) : '',
                    'approver': item.approver ? item.approver.first_name + ' ' + item.approver.last_name : '',
                })
            )
            this.$nextTick(() => this.resultList = temp )
        }
    },
    mounted() {
        this.searchParams = this.$refs.searchView.getSearchParams()
    },
    methods: {
        updateList: function () {
            this.searchWithParams(this.searchParams)
        },
        searchWithParams: function (params) {
            this.results = []
            this.loading = true
            this.searchParams = params
            this.restFetchParams(this.mealAllowanceUrl, params, this.handleResponse)
        },
        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
            this.showList()
        },
        showList: function () {
            this.editMode = false
        },
        editItem: function (item) {
            this.result = this.results.find(res => res.id === item.id)
            this.editMode = true
        },
        addItem: function () {
            this.result = null
            this.editMode = true
        },
        getTypeString: function (value) {
            if (value) {
                return this.$t('meal_allowance.increased')
            }
            return this.$t('meal_allowance.normal')
        }
    }
}
</script>

